import { useState } from 'react';
import type { ZodTypeAny, z } from 'zod';
import { ApiError } from './api';

/**
 * Мини-хелпер форм: валидация общей zod-схемой из @mafia/core на клиенте,
 * ошибки полей с сервера (409 TAKEN и т. п.) — в те же поля.
 */
export function useFormSubmit<S extends ZodTypeAny>(schema: S, submit: (data: z.infer<S>) => Promise<void>) {
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [formError, setFormError] = useState<string | null>(null);
  const [pending, setPending] = useState(false);

  async function handle(values: unknown) {
    setFormError(null);
    const parsed = schema.safeParse(values);
    if (!parsed.success) {
      const next: Record<string, string> = {};
      for (const issue of parsed.error.issues) next[issue.path.join('.')] ??= issue.message;
      setErrors(next);
      return;
    }
    setErrors({});
    setPending(true);
    try {
      await submit(parsed.data);
    } catch (err) {
      if (err instanceof ApiError) {
        if (Object.keys(err.fields).length) setErrors(err.fields);
        else setFormError(err.message);
      } else {
        setFormError('Сервер недоступен, попробуйте позже');
      }
    } finally {
      setPending(false);
    }
  }

  return { errors, formError, setFormError, pending, handle };
}
